import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { of, switchMap, tap } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { HealthCheckService } from '@cp/shared/core/services/health-check.service';
import { CompanyService } from '@cp/shared/data-access/company/company.service';
import { GoogleTagManagerService } from '@cp/shared/google-tag-manager/google-tag-manager.service';
import { PwaService } from './services/pwa.service';

@Component({
  selector: 'cp-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private _httpClient: HttpClient;

  public isAuthenticated$ = this._authService.isAuthenticated$.pipe(
    switchMap((isAuthenticated) =>
      isAuthenticated ? this._healthCheckService.healthCheck$ : of(false),
    ),
  );
  public auth0Error$ = this._authService.error$;

  constructor(
    _httpBackend: HttpBackend,
    private _authService: AuthService,
    private _healthCheckService: HealthCheckService,
    private _pwaService: PwaService,
    private _companyService: CompanyService,
    private _gtmService: GoogleTagManagerService,
  ) {
    this._httpClient = new HttpClient(_httpBackend);
  }

  public ngOnInit(): void {
    this._gtmService.setConfig({
      id: this._companyService.gtmId,
    });
    this._cacheSVG();

    window.addEventListener('beforeinstallprompt', (event) => {
      this._pwaService.onEvent(event);
    });

    window.addEventListener('appinstalled', () => {
      this._pwaService.unsetEvent();
    });
  }

  private _cacheSVG(): void {
    const svgFile = '/assets/svg/svg-defs.svg';
    const revision = '1';
    const debug = true;
    const revisionKey = 'inlineSVGrev';
    const svgDataKey = 'inlineSVGdata';

    if (localStorage.getItem(revisionKey) === revision && !debug) {
      const svgData = localStorage.getItem(svgDataKey) || '';
      document.body.insertAdjacentHTML('afterbegin', svgData);
      return;
    }

    this._httpClient
      .get(svgFile, { responseType: 'text' })
      .pipe(
        tap((data) => {
          document.body.insertAdjacentHTML('afterbegin', data);
          localStorage.setItem(svgDataKey, data);
          localStorage.setItem(revisionKey, revision);
        }),
      )
      .subscribe();
  }
}
